import { render, staticRenderFns } from "./account-settings.vue?vue&type=template&id=289e06d3&scoped=true&"
import script from "./account-settings.vue?vue&type=script&lang=js&"
export * from "./account-settings.vue?vue&type=script&lang=js&"
import style0 from "./account-settings.vue?vue&type=style&index=0&id=289e06d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e06d3",
  null
  
)

export default component.exports